import Black from './Inter-Black.ttf'
import Bold from './Inter-Bold.ttf'
import Italic from './Inter-Italic.ttf'
import Medium from './Inter-Medium.ttf'
import Regular from './Inter-Regular.ttf'
import SemiBold from './Inter-SemiBold.ttf'
import SemiBoldItalic from './Inter-SemiBoldItalic.ttf'

import { mapFontFaces } from '../utils'

const FONTS = [
  { style: 'normal', weight: 700, src: Bold },
  { style: 'normal', weight: 900, src: Black },
  { style: 'italic', weight: 400, src: Italic },
  { style: 'normal', weight: 500, src: Medium },
  { style: 'normal', weight: 400, src: Regular },
  { style: 'normal', weight: 600, src: SemiBold },
  { style: 'italic', weight: 600, src: SemiBoldItalic }
]

const Inter = mapFontFaces('Inter', FONTS)

export default Inter



// WEBPACK FOOTER //
// ./src/styles/fonts/Inter/index.js